import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import './ProductDetail.css';
import productData from '../data/productData';

const ProductDetail = () => {
  const { category, productId } = useParams();
  const [markdown, setMarkdown] = useState('');
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // 查找对应产品数据
    if (productData.products[category]) {
      const foundProduct = productData.products[category].find(p => p.id === productId);

      if (foundProduct) {
        setProduct(foundProduct);

        // 加载Markdown文件
        if (foundProduct.markdown) {
          import(`../assets/markdown/${foundProduct.markdown}.md`)
            .then(res => {
              fetch(res.default)
                .then(response => response.text())
                .then(text => {
                  setMarkdown(text);
                  setLoading(false);
                })
                .catch(err => {
                  console.error('Error fetching markdown:', err);
                  setError('无法加载产品详情');
                  setLoading(false);
                });
            })
            .catch(err => {
              console.error('Error importing markdown:', err);
              setError('该产品暂无详情说明');
              setLoading(false);
            });
        } else {
          setError('该产品暂无详情说明');
          setLoading(false);
        }
      } else {
        setError('找不到该产品');
        setLoading(false);
      }
    } else {
      setError('找不到该产品分类');
      setLoading(false);
    }
  }, [category, productId]);

  const handleGoBack = () => {
    // 回到产品页面的特定产品位置，同时传递分类信息
    navigate(`/products#${category}-${productId}`);
  };

  // 自定义渲染器，处理图片路径
  const renderers = {
    img: ({ node, ...props }) => {
      const src = props.src;
      // 处理不同类型的路径
      if (src) {
        if (src.startsWith('../')) {
          // 处理相对路径 ../
          return <img {...props} src={process.env.PUBLIC_URL + src.replace('../', '/')} alt={props.alt || '产品图片'} />;
        } else if (src.startsWith('/assets/')) {
          // 处理以/assets/开头的路径
          return <img {...props} src={process.env.PUBLIC_URL + src} alt={props.alt || '产品图片'} />;
        }
      }
      return <img {...props} alt={props.alt || '产品图片'} />;
    }
  };

  return (
    <div className="product-detail-page">
      {/* 页面头部 */}
      <div className="page-header-products">
        <div className="header-bg-products">
          <div className="header-content-products">
            <h1>{product?.name || '产品详情'} <span className="en-title-products">Product Detail</span></h1>
            <div className="breadcrumb-products">
              <Link to="/">首页</Link> &gt;
              <Link to="/products">产品中心</Link> &gt;
              <Link to={`/products#${category}`}>{productData.categories.find(c => c.id === category)?.name || '产品分类'}</Link> &gt;
              {product?.name || '产品详情'}
            </div>
          </div>
        </div>
      </div>

      {/* 产品详情内容 */}
      <div className="product-detail-container">
        <div className="product-detail-back-button product-detail-top-back" onClick={handleGoBack}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          <span>返回产品列表</span>
        </div>

        {loading ? (
          <div className="product-detail-loading">加载中...</div>
        ) : error ? (
          <div className="product-detail-error">{error}</div>
        ) : (
          <div className="markdown-content">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
              components={renderers}
            >
              {markdown}
            </ReactMarkdown>
          </div>
        )}

        <div className="product-detail-back-button product-detail-bottom-back" onClick={handleGoBack}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          <span>返回产品列表</span>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;